import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import { ThemedTitleV2 } from '@refinedev/mui'

import { useAuth0 } from '@/utils/auth/auth0'

export const Login: React.FC = () => {
  const { loginWithRedirect } = useAuth0()

  return (
    <Container
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        display="flex"
        gap="36px"
        justifyContent="center"
        flexDirection="column"
        alignItems={'center'}
      >
        <img
          src="/Fundsorter-h-black800px.png"
          alt="Fundsorter Logo"
          width="50%"
          style={{
            margin: '0 auto',
          }}
        />

        <Button
          style={{ width: '240px' }}
          size="large"
          variant="contained"
          onClick={() => loginWithRedirect({
            prompt: 'select_account' // Forces Auth0 to show account selection
          })}
        >
          Sign in
        </Button>
      </Box>
    </Container>
  )
}
